module.exports = __webpack_public_path__ + "static/media/user2.9b9729f2.jpeg";